import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const updateLanguages = (languageId: number, existingValues: CodeComplexValue<number>[], newValue: string) => {

  const existingDescription = existingValues ?
    existingValues.find(desc => desc.value === languageId)
    : undefined;

  const newDescription = {
    value: languageId,
    ...(!!newValue && { description: newValue })
  };

  const updatedValues = [
    ...existingValues.map(desc => desc === existingDescription && newDescription
      ? newDescription
      : desc)
  ];

  return !existingDescription && !!newDescription ? [...updatedValues, newDescription] : updatedValues;
};
